//-----validation forms
function validateEmail(email) {
    let email_string = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email.match(email_string)) {
        return true;
    } else {
        return false;
    }

}

function validatePassword(pw) {
    return pw.length > 5;
    // return /[A-Z]/       .test(pw) &&
    //     /[a-z]/       .test(pw) &&
    //     /[0-9]/       .test(pw) &&
    //     /[^A-Za-z0-9]/.test(pw) &&
    //     pw.length > 4;

}

function validateName(name) {
    return (/[a-zA-Z]/.test(name) || /[а-яА-Я]/.test(name)) && name.length >= 3;
}

function validateTel(tel) {
    return (/[0-9]/.test(tel) && tel.length >= 10);
}

function formValidation() {
    let forms = document.querySelectorAll('.js-form-validation');
    if (!forms.length > 0) {
        return;
    }

    forms.forEach(function(form, i) {
        let input = form.querySelector('input[type="button"], #subscribe-popup-btn-send');
        input.addEventListener('click', function(e) {
            let validInputs = input.closest('form').querySelectorAll('input:not([type="button"]):not([type="hidden"])');
            let valid = true;
            for(let i=0;i<validInputs.length;i++){
                let validInput = checkValid(validInputs[i]);
                if(validInput == false){
                    valid = false;
                    break;
                }
            }

            if (valid == true) {
                form.querySelector('.form-error').textContent = '';
                form.submit();
            } else {
                // form.querySelector('.form-error').textContent = window.error_fields.dont_valid_inputs;
            }
        })
    });
}
formValidation();



function validateInputs(input) {
    if (input) {
        checkValid(input);
    } else {
        let inputs = document.querySelectorAll('.js-form-validation input:not([name="address[default]"]):not([type="submit"])');
        inputs.forEach(function(item) {
            item.addEventListener('change', function(e) {
                checkValid(item);
            })
        })
    }
}
validateInputs();

function checkValid(item) {
    var validation = true;
    let field = item;
    let fieldValue = field.value.trim();
    if (fieldValue === '' && item.hasAttribute('required') && item.type != 'checkbox') {
        validation = false;
        field.closest('form').querySelector('.form-error').textContent = window.error_fields.cant_be_blank;
    } else {
        if (item.getAttribute('type') == 'email') {
            let field = item;
            if (validateEmail(field.value) != true) {
                validation = false;
                field.closest('form').querySelector('.form-error').textContent = window.error_fields.invalid_email;
            } else {
                field.closest('form').querySelector('.form-error').textContent = '';
            }
        } else
        if (item.hasAttribute('data-name')) {
            let field = item;
            if (validateName(field.value) != true) {
                validation = false;
                field.closest('form').querySelector('.form-error').textContent = window.error_fields.invalid + field.placeholder;
            } else {
                field.closest('form').querySelector('.form-error').textContent = '';
            }
        } else
        if (item.getAttribute('type') == 'password') {
            let field = item;
            let pass = item.closest('form').querySelector('[name="customer[password]"]').value;
            let confirmPass = item.value;
            if (validatePassword(field.value) == false) {
                validation = false;
                field.closest('form').querySelector('.form-error').textContent = window.error_fields.pass_be_five;
            }else if(item.hasAttribute('confirm') && pass === confirmPass){
                field.closest('form').querySelector('.form-error').textContent = '';
                if(item.hasAttribute('confirm') && pass !== confirmPass){
                    validation = false;
                    field.closest('form').querySelector('.form-error').textContent = window.error_fields.pass_dont_match;
                }
            }else {
                field.closest('form').querySelector('.form-error').textContent = '';
            }
        } else
        if (item.getAttribute('type') == 'checkbox') {
            let field = item;
            if (field.checked != true) {
                validation = false;
                field.closest('form').querySelector('.form-error').textContent = window.error_fields.need_accept_terms;
            } else {
                field.closest('form').querySelector('.form-error').textContent = '';
            }
        } else
        if (item.getAttribute('type') == 'tel') {
            let field = item;
            if (validateTel(field.value) != true) {
                validation = false;
                field.closest('form').querySelector('.form-error').textContent = window.error_fields.invalid_phone;
            } else {
                field.closest('form').querySelector('.form-error').textContent = '';
            }
        }
    }
    return validation;
}
//-----validation forms end
